import { IContact } from '@/types';
import { getUrl } from '@/utils/api';

function useContacts(filter?: string) {
  let url = `v1/contacts`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as IContact[],
  };
}

export default useContacts;
